import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { emptyState } from "../lib/engine";
import CityEditor, { C, FONT_HEAD, FONT_BODY } from "../components/CityEditor";
import { Toaster } from "sonner";
import { Building2 } from "lucide-react";

// Walikota — portal login + editor kota miliknya (CityEditor bersama)
export default function Walikota() {
  const [token, setToken] = useState(localStorage.getItem("mayor_token") || "");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [me, setMe] = useState(null);

  useEffect(() => {
    if (token) api.mayorMe(token).then(setMe).catch(() => {});
  }, [token]);

  async function login(e) {
    e.preventDefault();
    setMsg("");
    try {
      const j = await api.mayorLogin(username, password);
      localStorage.setItem("mayor_token", j.token);
      setToken(j.token);
    } catch (err) { setMsg(err.message); }
  }

  if (!token) {
    return (
      <div style={{
        minHeight: "100vh", display: "grid", placeItems: "center", fontFamily: FONT_BODY,
        background: "radial-gradient(1100px 620px at 15% -5%, #f8f5e8, #efece0 70%)"
      }}>
        <Toaster theme="light" position="bottom-center" />
        <form onSubmit={login} style={{
          background: "#fff", borderRadius: 26, padding: "38px 34px", width: 370,
          boxShadow: "0 18px 50px rgba(20,20,20,0.12)"
        }}>
          <span style={{ width: 40, height: 40, borderRadius: 14, background: C.blue, display: "grid", placeItems: "center", marginBottom: 14 }}>
            <Building2 size={19} color="#fff" />
          </span>
          <p style={{ margin: 0, fontSize: 11, letterSpacing: 3, color: C.sub, textTransform: "uppercase", fontWeight: 700 }}>Jawsel</p>
          <h1 style={{ margin: "6px 0 4px", fontFamily: FONT_HEAD, fontSize: 26, fontWeight: 800, color: C.ink, letterSpacing: -0.6 }}>Portal Walikota</h1>
          <p style={{ margin: "0 0 22px", fontSize: 13, color: C.sub }}>Masuk untuk membangun kotamu</p>
          <input data-testid="mayor-login-username" value={username} onChange={e => setUsername(e.target.value)} placeholder="Username"
            style={{ width: "100%", padding: "12px 14px", marginBottom: 10, background: C.hoverBg, border: `1.5px solid ${C.line}`, borderRadius: 14, color: C.ink, fontSize: 14, outline: "none", fontFamily: FONT_BODY }} />
          <input data-testid="mayor-login-password" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Password"
            style={{ width: "100%", padding: "12px 14px", marginBottom: 16, background: C.hoverBg, border: `1.5px solid ${C.line}`, borderRadius: 14, color: C.ink, fontSize: 14, outline: "none", fontFamily: FONT_BODY }} />
          <button data-testid="mayor-login-btn" type="submit"
            style={{ width: "100%", padding: 13, background: C.blue, color: "#fff", border: 0, borderRadius: 99, fontWeight: 700, fontSize: 14, transition: "opacity 0.15s", fontFamily: FONT_BODY }}
            onMouseEnter={e => e.target.style.opacity = "0.85"} onMouseLeave={e => e.target.style.opacity = "1"}>
            Masuk
          </button>
          {msg && <p data-testid="mayor-login-msg" style={{ color: C.danger, fontSize: 13, marginTop: 12, marginBottom: 0 }}>{msg}</p>}
        </form>
      </div>
    );
  }

  return (
    <div style={{ height: "100vh" }}>
      <CityEditor
        title={me?.city_name || "..."}
        loadState={() => api.mayorGetState(token).then(s => s.state || emptyState())}
        saveState={(st) => api.mayorSaveState(token, st)}
        onLogout={() => { localStorage.removeItem("mayor_token"); setToken(""); }}
      />
    </div>
  );
}
